import { render, staticRenderFns } from "./StatisticsCardVertical.vue?vue&type=template&id=d717fe2e&scoped=true&"
import script from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardVertical.vue?vue&type=style&index=0&id=d717fe2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d717fe2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VIcon,VSpacer})
